import { IconButton } from '@affine/component';
import { openDesktopDownload } from '@affine/core/modules/open-in-app/utils';
import { GlobalStateService } from '@affine/core/modules/storage';
import { useI18n } from '@affine/i18n';
import { CloseIcon } from '@blocksuite/icons/rc';
import { LiveData, useLiveData, useService } from '@toeverything/infra';
import { useMemo } from 'react';

import * as styles from './desktop-search-hint.css';

const DISMISSED_KEY = 'quicksearch-desktop-hint-dismissed';

/**
 * Under a web search that needs the server: the desktop app keeps more of
 * the workspace searchable on this device. Closed once, it stays closed on
 * this device.
 */
export const DesktopSearchHint = ({ visible }: { visible: boolean }) => {
  const t = useI18n();
  const globalState = useService(GlobalStateService).globalState;
  const dismissed = useLiveData(
    useMemo(
      () => LiveData.from(globalState.watch<boolean>(DISMISSED_KEY), false),
      [globalState]
    )
  );
  if (!visible || dismissed) return null;
  return (
    <div className={styles.hint} data-testid="quick-search-desktop-hint">
      <span className={styles.text}>
        {t['com.streamlain.quicksearch.desktopHint.text']()}
      </span>
      <button
        type="button"
        className={styles.download}
        data-testid="quick-search-desktop-hint-download"
        onClick={() => void openDesktopDownload()}
      >
        {t['com.streamlain.quicksearch.desktopHint.download']()}
      </button>
      <IconButton
        size="12"
        icon={<CloseIcon />}
        aria-label={t['com.streamlain.quicksearch.desktopHint.close']()}
        data-testid="quick-search-desktop-hint-close"
        onClick={() => globalState.set(DISMISSED_KEY, true)}
      />
    </div>
  );
};
